module.exports = __webpack_public_path__ + "img/wenhua (1).838920b3.png";